import Button from "@mui/material/Button";
import weightToggleIcon from "../../assets/icons/weightToggle.png";
import Switch from "@mui/material/Switch";
import PropTypes from "prop-types";
// redux
import { useSelector, useDispatch } from "react-redux";
import { loadWeightToggleState } from "store/features/matchNetSlice";

function MatchNetWeightToggle({ isWeighted = false, studyTypeMethod = "" }) {
    const dispatch = useDispatch();
    const matchNetWeightToggle = useSelector((state) => state.matchNetStore.weightToggle);
    const weightValue = matchNetWeightToggle.find((item) => item.studyTypeMethodTitle === studyTypeMethod)?.weightToggle;
    const handleWeightToggleChange = () => {
        // setWeightToggle((prev) => prev.map((item) => (item.studyTypeMethodTitle === studyTypeMethod ? { ...item, weightToggle: !item.weightToggle } : item)));
        const updateToggle = matchNetWeightToggle.map((item) => (item.studyTypeMethodTitle === studyTypeMethod ? { ...item, weightToggle: !item.weightToggle } : item));
        dispatch(loadWeightToggleState(updateToggle))
    };
    return (
        <Button
            size="small"
            className={isWeighted ? (weightValue ? "custom-btn custom-btn-outlined-3 color-white me-4 bold-content liner-light-blue-background" : "custom-btn custom-btn-outlined-2 color-blue me-4 bold-content") : "custom-btn me-4 bold-content"}
            disabled={!isWeighted}
            variant="outlined"
            startIcon={
                <img
                    className={!isWeighted ? "invert" : weightValue ? "image-white" : ""}
                    style={{
                        height: "16px",
                    }}
                    src={weightToggleIcon}
                />
            }
        >
            Weight
            <Switch
                size="small"
                disabled={!isWeighted}
                checked={Boolean(isWeighted && weightValue)}
                onChange={handleWeightToggleChange}
                sx={{
                    "& .Mui-checked": {
                        "& + .MuiSwitch-track": {
                            backgroundColor: "#ffffff", // Track color when ON
                        },
                    },
                }}
            />
        </Button>
    );
}

MatchNetWeightToggle.propTypes = {
    isWeighted: PropTypes.bool,
    // weightToggle: PropTypes.bool,
    // setWeightToggle: PropTypes.func,
    studyTypeMethod: PropTypes.string,
};

export default MatchNetWeightToggle;
